export default __webpack_public_path__ + "static/AzoSansRegular-1813b0de207ec06fca1d2b0969274a2a.woff";